import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/node_modules/antd/lib/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/src/components/MaterialsLibrary/SearchComponent.tsx");
